import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import { FilterCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { PlatformFilterCondition } from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { listFormatter } from "@app/util/fieldModel/impl/fieldUtil";
import GroupsFilter, { GROUPS_FILTER_OPERATORS } from "@app/util/filters/GroupsFilter";
import { getRegularFieldConditionValue } from "@app/util/viewModel/convertFromPlatformFilterModel";

import Field, { FieldProperties } from "./Field";

class GroupsField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "groups",
        filterInstances: {
          groups: GroupsFilter,
        },
        operators: [...GROUPS_FILTER_OPERATORS],
      },
      customGridProperties: {
        cellRenderer: "groupsCellRenderer",
      },
      extraPlatformFiltersGetter: () => ({ includeGroups: true }),
      features: [
        FieldFeature.GROUP_FIELD,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.SUPPORTS_SET_FILTER,
        FieldFeature.VISIBLE_BY_DEFAULT,
        FieldFeature.NON_INTEGRATION,
        FieldFeature.DATA_VIEW,
        FieldFeature.RELATIONSHIPS_CATEGORY,
        FieldFeature.HISTORY_FIELD,
      ],
      type: FieldType.LIST,
      valueFormatter: listFormatter("name"),
      ...data,
    });
  }

  get isDefaultValueAllowed() {
    return true;
  }

  convertFromPlatformCondition(
    filterCondition: PlatformFilterCondition
  ): FilterCondition | undefined {
    // group field filter is applied as a meta-filter, thus it doesn't have a name
    // so we're adding a field name back for it.
    const condition = getRegularFieldConditionValue(this, {
      [this.platformFilterName]: filterCondition,
    });

    // since GroupsField is a Set field (has SUPPORTS_SET_FILTER feature),
    // getRegularFieldConditionValue resolved $nin as noneOf operator. However,
    // due to UI/UX reasons, it should really be notIn. Which we are handling here.
    if (condition?.operator === FilterOperator.NONE_OF) {
      return { ...condition, operator: FilterOperator.NOT_IN };
    }
    return condition;
  }
}

export default GroupsField;
